// controllerMenu.js
var ControllerMenu = pc.createScript('controllerMenu');

ControllerMenu.attributes.add('anim1', {type:'asset', title: 'anim1'});
ControllerMenu.attributes.add('anim2', {type:'asset', title: 'anim2'});
ControllerMenu.attributes.add('sndOpn', {type:'asset', title: 'cntrlOpen'});
ControllerMenu.attributes.add('sndCls', {type:'asset', title: 'cntrlClose'});
ControllerMenu.attributes.add('sndSld', {type:'asset', title: 'cntrlSlide'});
ControllerMenu.attributes.add('menu', {type:'entity', title: 'rollMenuEntity'});
ControllerMenu.attributes.add('cameraParent', {type: 'entity', title: 'Camera Parent'});
ControllerMenu.attributes.add('sceneIndex', {type: 'string', title: 'scenes', array: true});

// initialize code called once per entity
ControllerMenu.prototype.initialize = function() {
    this.app.on('controller:button', this.onControllerDown, this);
    this.app.on('controllers:clones', this.addController, this);
    this.app.on('controller:axis', this.rollMenu, this);
    this.app.on('rollMenu:counter', this.sceneLoader, this);
    currentScene = null;
    nextScene = null;
    cCounter = 0;
    sCounter = 7;
    lAnim = null;
    rAnim = null;
    onceL = false;
    onceR = false;
    axisOnce = true;
    roMenu = null;
    dealy = 0;
    master = null;
    crAxis = 0;
};

ControllerMenu.prototype.addController = function(tEnt, tMen, hand) {

    if(hand == 'left'){
       lAnim = tEnt.animation;
    } else {
       rAnim = tEnt.animation;
    }
    if(cCounter === 1){
        master = hand;
        roMenu = tMen;
    }

    cCounter += 1;
};

ControllerMenu.prototype.onControllerDown = function(tHand, tBtn, tState) {

    if(tHand == 'left' && tBtn == 1 && tState == 'down'){
        if(!onceL){
            lAnim.play(this.anim2.name);
            if(master == 'left'){roMenu.enabled = true;}
            roMenu.parent.children[4].sound.play('open');
        }
        onceL = true;
    }
    if(tHand == 'left' && tBtn == 1 && tState == 'up'){
        if(onceL){
            lAnim.play(this.anim1.name);
            roMenu.parent.children[4].sound.play('close');
            if(master == 'left'){
                this.app.fire('sceneLoader:loadScene', this.sceneIndex[sCounter]);
                roMenu.enabled = false;
            }
        }
        onceL = false;
    }
    if(tHand == 'right' && tBtn == 1 && tState == 'down'){
        if(!onceR){
            rAnim.play(this.anim2.name);
            roMenu.parent.children[4].sound.play('open');
            if(master == 'right'){roMenu.enabled = true;}
        }
        onceR = true;
    }
    if(tHand == 'right' && tBtn == 1 && tState == 'up'){
        if(onceR){
            rAnim.play(this.anim1.name);
            roMenu.parent.children[4].sound.play('close');
            if(master == 'right'){
                this.app.fire('sceneLoader:loadScene', this.sceneIndex[sCounter]);
                roMenu.enabled = false;
            }
        }
        onceR = false;
    }
};

ControllerMenu.prototype.rollMenu = function(axis) {
    crAxis = axis;
    this.app.fire('debug', 'theAxis:', axis, 0);
    if(axis !== 0){
        if(axisOnce){
            if(axis < 0){
                roMenu.script.rollMenu.goLeft();
                roMenu.parent.children[4].sound.play('swipe');
                if(sCounter > 0){
                    sCounter -= 1;
                } else {
                    sCounter = this.sceneIndex.length-1;
                }
            }
            if(axis > 0){
                roMenu.script.rollMenu.goRight();
                roMenu.parent.children[4].sound.play('swipe');
                if(sCounter < this.sceneIndex.length-1){
                    sCounter += 1;
                } else {
                    sCounter = 0;
                }
            }
            axisOnce = false;
          // this.app.fire('debug', 'theAxis:', axisOnce, 0);
        }
    }
    if(axis === 0){
      axisOnce = true;
      //this.app.fire('debug', 'theAxis:', axisOnce, 0);
    } else {
        axisOnce = false;
       //this.app.fire('debug', 'theAxis:', axisOnce, 0);
    }
};

ControllerMenu.prototype.sceneLoader = function(cnt){
    currentScene = nextScene;
    nextScene = this.sceneIndex[cnt];
    //this.app.fire('debug', "scene:", nextScene,2);
};


// update code called every frame
ControllerMenu.prototype.update = function(dt) {

};

// swap method called for script hot-reloading
// inherit your script state here
// ControllerMenu.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

